<div class="loading-shade"
  *ngIf="showLoader">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<section class="comments-content"
  *ngIf="comments$ | async as comments">
  <div mat-dialog-title
    class="d-flex justify-content-between">
    <strong>{{'forms.common.' + options?.btnConfig?.tooltip | translate}}</strong>
    <button mat-icon-button
      (click)="cancel()">
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>

  <mat-dialog-content *ngIf="comments?.length; else emptyCase ">


    <cdk-accordion class="comments-accordion">
      <cdk-accordion-item *ngFor="let comment of comments; let index = index;"
        #accordionItem="cdkAccordionItem"
        class="comments-accordion__item"
        role="button"
        tabindex="0"
        [attr.id]="'accordion-header-' + index"
        [attr.aria-expanded]="accordionItem.expanded"
        [attr.aria-controls]="'accordion-body-' + index">
        <div class="comments-accordion__item__header"
          (click)="accordionItem.toggle()">
          <img src="assets/images/user-logo.png"
            alt="App Brand"
            class="comments-accordion__item__img" />
          <span>{{ comment.fullName }}</span>
          <span>{{ comment.addingDate | date: 'EEEE, M/d/yy, h:mm a'}}</span>
          <span class="comments-accordion__item__status"
            [class]="'comments-accordion__item__status__'+ (comment.status ||'notCompleted' ) | lowercase  ">
            <mat-icon inline
              [ngbTooltip]="('forms.common.stepper.' + (comment.status ||'notCompleted' )) | translate"
              placement="top">
              {{comment.status === tabStatusEnum.COMPLETED ? 'check_circle' : 'cancel'}}
            </mat-icon>
          </span>
          <mat-icon
            inline>
            {{ accordionItem.expanded ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </div>
        <div class="comments-accordion__item__body"
          role="region"
          [style.display]="accordionItem.expanded ? '' : 'none'"
          [attr.id]="'accordion-body-' + index"
          [attr.aria-labelledby]="'accordion-header-' + index">
          <div class="comment-content">
            <div class="comment_content__item"
              *ngFor="let col of columns"
              [class]="'comment_content__col--'+col.key">
              <span class="comment_content__label"
                *ngIf="col.label">
                {{ (translationsKey+col.label) | translate }} :
              </span>
              <span class="comment_content__value "
                *ngIf="col.key">
                <ng-container *ngIf="col.translated else normal">
                  {{ (translationsKey+comment[col.key]) | translate}}
                </ng-container>
                <ng-template #normal>
                  {{ comment[col.key] }}
                </ng-template>
              </span>
            </div>
          </div>
        </div>
      </cdk-accordion-item>
    </cdk-accordion>


  </mat-dialog-content>
</section>



<ng-template #emptyCase>
  <ng-container *ngIf="!hasError && !showLoader">
    <div class="row">
      <div class="col-12 text-center">
        <img src="assets/images/no-comments-found.png"
          alt="App Brand" />
      </div>
    </div>
    <div class="row text-center m-3">
      <div class="col-md-12">
        <div class="alert custom-alert-info">
          {{ 'forms.common.No Comments Exsit' | translate }}
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="hasError"
    class="d-flex flex-column justify-content-center align-items-center">
    <span class="display-3  text-warning">
      <mat-icon
        inline>
        error_outline
      </mat-icon>
    </span>
    <strong class="mb-4">{{ 'forms.common.Something went wrong, please try again later' | translate }}</strong>
  </div>
</ng-template>
